import { TransportNote } from './../model/transport-note';
import { Injectable } from '@angular/core';
import { Identity } from '@sdbn/common';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { TransportDetails } from '../model/transport-details';
import { DocumentPreview } from '../model/document-preview';
import { PictureDocumentDetails } from '../model/picture-document-details';
import { AppDocumentDetails } from '../model/app-document-details';
import { RoutingPositionLog } from '../model/routing-position';
import { TransportWeighing } from '../model/transport-weighing';
import { map } from 'rxjs/operators';
import { SupplementaryEquipment } from '../model/supplementary-equipment';
import { TransportOptionSelection } from '../../transport-options-panel/transport-options-panel.model';

@Injectable({
  providedIn: 'root'
})
export class TransportDetailsService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getTransportDetails(identity: Identity): Observable<TransportDetails> {
    return this.appServerAPI.execute<TransportDetails>('/client/control/transport/details', identity);
  }

  public getRoutingPositionLogs(identity: Identity): Observable<RoutingPositionLog[]> {
    return this.appServerAPI.execute<RoutingPositionLog[]>('/client/control/transport/details/log', identity).pipe(
      map(r => r.map(rp => new RoutingPositionLog(rp)))
    );
  }

  public getSupplementaryEquipment(identity: Identity): Observable<SupplementaryEquipment[]> {
    return this.appServerAPI.execute<SupplementaryEquipment[]>('/client/control/transport/details/supplementary-equipment', identity);
  }

  public getTransportOptions(identity: Identity): Observable<TransportOptionSelection[]> {
    return this.appServerAPI.execute<TransportOptionSelection[]>('/client/control/transport/details/transport-options', identity);
  }

  public getTransportWeighings(identity: Identity): Observable<TransportWeighing[]> {
    return this.appServerAPI.execute<TransportWeighing[]>('/client/control/transport/details/transport-weighings', identity);
  }

  public getDocumentPreviews(identity: Identity): Observable<DocumentPreview[]> {
    return this.appServerAPI.execute<DocumentPreview[]>('/client/control/transport/details/document-previews', identity);
  }

  addNote(note: TransportNote): Observable<void> {
    return this.appServerAPI.execute<void>('/client/control/transport/details/add-note', note);
  }

  public getPictureDocumentDetails(preview: DocumentPreview): Observable<PictureDocumentDetails> {
    return this.appServerAPI.execute<PictureDocumentDetails>('/client/control/transport/details/picture-document-details',
      preview.identifier
    );
  }

  public getAppDocumentDetails(preview: DocumentPreview): Observable<AppDocumentDetails> {
    return this.appServerAPI.execute<AppDocumentDetails>('/client/control/transport/details/app-document-details',
      preview.identifier
    );
  }

  public createPrintout(transportIdentity: Identity) {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'weighing-printout');

    // keep focus in current window
    window.focus();

    const url = `/client/control/transport/details/printout`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, transportIdentity).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

}
